import { ref } from 'vue';
import { useRouter } from 'vue-router';

// 存储"做同款"数据的状态
const similarMusicData = ref<any>(null);

// 设置"做同款"音乐数据的私有方法
const setSimilarMusicData = (data: any) => {
  similarMusicData.value = data;
};

// 导出组合式函数
export const useMusicCreate = () => {
  const router = useRouter();

  /**
   * 保存音乐数据用于"做同款"功能
   * @param musicData 音乐数据
   * @param currentRoute 当前路由路径，用于判断是否在创建页
   */
  const saveMusicData = (musicData: any, currentRoute?: string) => {
    // 数据预处理
    const processedData = {
      prompt: musicData.prompt || '',
      tags: musicData.tags || '',
      instrumental: musicData.instrumental || false,
      lyrics: musicData.lyrics || '',
      title: musicData.title || '',
      mode: musicData.mode || 'advanced' // 默认切换到高级模式
    };
    
    // 保存数据到状态
    setSimilarMusicData(processedData);
    
    // 判断是否在创建页
    if (currentRoute === '/create') {
      // 在创建页面内点击做同款时，不需要跳转
      // 页面会通过getSimilarMusicData获取数据并应用
    } else {
      // 不在创建页，需要跳转到创建页
      
      // 使用setTimeout确保数据已保存到状态中
      setTimeout(() => {
        // 导航到创建页面
        router.push({
          path: '/create'
        });
      }, 100);
    }
  };

  // 获取"做同款"数据
  const getSimilarMusicData = () => {
    return similarMusicData.value;
  };

  // 清除"做同款"数据
  const clearSimilarMusicData = () => {
    similarMusicData.value = null;
  };

  return {
    saveMusicData,
    getSimilarMusicData,
    clearSimilarMusicData
  };
}; 